module.exports = __webpack_public_path__ + "img/min-sider.2b352f26.svg";